/* Copyright (c) 2023 Xperi. All Rights Reserved. */

export class MouseOperations {
    static MOUSE_CLICK: string = 'click';

    static MOUSE_CONTEXT_MENU: string = 'contextmenu';

    static MOUSE_DOWN: string = 'mousedown';

    static MOUSE_ENTER: string = 'mouseenter';

    static MOUSE_LEAVE: string = 'mouseleave';

    static MOUSE_MOVE: string = 'mousemove';

    static MOUSE_OUT: string = 'mouseout';

    static MOUSE_OVER: string = 'mouseover';

    static MOUSE_UP: string = 'mouseup';

    static MOUSE_WHEEL: string = 'wheel';
}
